import React from 'react'
import RemessaPagamentoFormPageContainer from './RemessaPagamentoFormPageContainer'

export class RemessaPagamentoFormPage extends React.Component {
  render() {
    return <RemessaPagamentoFormPageContainer {...this.props} />
  }
}
